import axios from 'axios'

export function getPage(locale, slug) {
  return axios.get('api/sales-static/pages', {
    params: { slug, locale },
  })
}
